import Layout from '@/layout/index.vue'

export const NotificationsRedirectRoute = {
  path: '/notification-route/:componentName/:itemId',
  component: Layout,
  children: [
    {
      path: '',
      component: (): Promise<any> =>
        import(
          '@/features/user-notifications/views/notifications-redirect.vue'),
      name: 'NotificationsRedirectRoute',
      meta: {
        title: '',
        requiresAuth: false
      }
    }
  ]
}
